/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Land_Skin_InstructionInputs */

const en_land_skin_instruction = /** @type {(inputs: Land_Skin_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once unlocked, go to Settings > Land Style to use it.`)
};

const ar_land_skin_instruction = /** @type {(inputs: Land_Skin_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بعد فتحه، انتقل إلى الإعدادات > نمط الأرض لاستخدامه.`)
};

const de_land_skin_instruction = /** @type {(inputs: Land_Skin_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehe nach dem Freischalten zu Einstellungen > Land-Stil, um ihn zu verwenden.`)
};

const es_land_skin_instruction = /** @type {(inputs: Land_Skin_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una vez desbloqueado, ve a Ajustes > Estilo de terreno para usarlo.`)
};

const fr_land_skin_instruction = /** @type {(inputs: Land_Skin_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une fois débloqué, accédez à Paramètres > Style de sol pour l’utiliser.`)
};

const it_land_skin_instruction = /** @type {(inputs: Land_Skin_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dopo averlo sbloccato, vai su Impostazioni > Stile del terreno per usarlo.`)
};

const ja_land_skin_instruction = /** @type {(inputs: Land_Skin_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アンロック後、設定 > ランドスタイルから使用できます。`)
};

const ko_land_skin_instruction = /** @type {(inputs: Land_Skin_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잠금 해제 후 설정 > 랜드 스타일에서 사용할 수 있어요.`)
};

const pt_br_land_skin_instruction = /** @type {(inputs: Land_Skin_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Após desbloquear, acesse Configurações > Estilo de terreno para usá-lo.`)
};

const ru_land_skin_instruction = /** @type {(inputs: Land_Skin_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`После разблокировки перейдите в Настройки > Стиль земли, чтобы использовать его.`)
};

const th_land_skin_instruction = /** @type {(inputs: Land_Skin_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมื่อปลดล็อกแล้ว ไปที่ การตั้งค่า > สไตล์พื้นดิน เพื่อใช้งาน`)
};

const tr_land_skin_instruction = /** @type {(inputs: Land_Skin_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilidi açtıktan sonra kullanmak için Ayarlar > Arazi Türü bölümüne git.`)
};

const zh_cn_land_skin_instruction = /** @type {(inputs: Land_Skin_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解锁后，前往设置 > 土地皮肤即可使用。`)
};

const zh_tw_land_skin_instruction = /** @type {(inputs: Land_Skin_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解鎖後，可前往「設定」>「土地造型」套用。`)
};

/**
* | output |
* | --- |
* | "Once unlocked, go to Settings > Land Style to use it." |
*
* @param {Land_Skin_InstructionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const land_skin_instruction = /** @type {((inputs?: Land_Skin_InstructionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Land_Skin_InstructionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_land_skin_instruction(inputs)
	if (locale === "ar") return ar_land_skin_instruction(inputs)
	if (locale === "de") return de_land_skin_instruction(inputs)
	if (locale === "es") return es_land_skin_instruction(inputs)
	if (locale === "fr") return fr_land_skin_instruction(inputs)
	if (locale === "it") return it_land_skin_instruction(inputs)
	if (locale === "ja") return ja_land_skin_instruction(inputs)
	if (locale === "ko") return ko_land_skin_instruction(inputs)
	if (locale === "pt_br") return pt_br_land_skin_instruction(inputs)
	if (locale === "ru") return ru_land_skin_instruction(inputs)
	if (locale === "th") return th_land_skin_instruction(inputs)
	if (locale === "tr") return tr_land_skin_instruction(inputs)
	if (locale === "zh_cn") return zh_cn_land_skin_instruction(inputs)
	return zh_tw_land_skin_instruction(inputs)
});